import { NgModule } from '@angular/core';
import { ContainerComponent } from './container.component';

@NgModule({
  imports: [],
  declarations: [ContainerComponent],
  exports: [ContainerComponent],
})
export class RdContainerModule {}
